import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Menu, MenuItem } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { Avatar, AvatarWrapperBox } from './FsAvatarNavMenu.style-elements';

const FsAvatarNavMenu: React.FC = () => {
  const { setIsVerified } = useAppContext();
  const history = useHistory();
  const { isBlocked } = useAppContext();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement>();
  const open = Boolean(anchorEl);

  const redirect = (pathname: Routes): void => {
    history.push({ pathname });
  };

  const handleIconButtonClick = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(undefined);
  };

  const handleRedirect = (): void => {
    handleClose();
    redirect(Routes.PROFILE_SETTINGS);
  };

  const handleLogout = (): void => {
    setIsVerified(false);
    handleClose();
    redirect(Routes.LOGIN);
  };

  return (
    <Box>
      <AvatarWrapperBox>
        <Avatar variant="contained" onClick={handleIconButtonClick}>
          MK
        </Avatar>
      </AvatarWrapperBox>
      <Menu
        data-test="transaction-contextual-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 50,
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        {!isBlocked && (
          <MenuItem onClick={handleRedirect}>
            <span>{defaultLocales.yourProfile}</span>
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout}>
          <span>{defaultLocales.logOut}</span>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default FsAvatarNavMenu;
